import { RiskItem } from './quotationRequest.model';

export interface PriceRequestModel {
  ProductCode: string;
  DistributorCode: string;
  PromotionCode?: string | null;
  SponsorEmail?: string | null;
  Email?: string | null;
  ContextId: string;
  Address: AddressModel;
  SubscriptionInformation: MrhSubscriptionInformationModel;
  RiskItems: RiskItem[];
  CoverageDurationInMonths: number | null;
  LessorName?: string;
}

export interface AddressModel {
  StreetNumberAndName: string;
  ZipCode: string;
  City: string;
  Country: string;
}

export interface MrhSubscriptionInformationModel {
  housingType: string;
  floor: string;
  ResidenceType: string | null;
  OccupationStatus: string;
  RoomCount: number | null;
  RoomCountGt40M2: number;
  HasClaims: boolean;
  DeductibleType?: string | null;
  SchoolInsuranceType?: string | null;
  HasSchoolInsuranceOption?: boolean | null;
  HasOptionVelo?: boolean | null;
  ValueObjectOptionType?: string | null;
  QuotationDate?: Date | null;
  HasSwimmingPool: boolean;
  HasVeranda: boolean;
  VerandaType?: string | null;
  HasNomadBusinessOption?: boolean | null;
  DependencyType?: string;
  HasGreenEnergyProductionInstallation: boolean;
  VYVCollaboratorDiscount?: string | null;
  CommercialLatitudeRequestedType?: string | null;
  QuotationReference?: string | null;
}
export type DependencyTypes =
  | 'Aucune'
  | 'MoinsDe50m2'
  | 'MoinsDe40m2'
  | 'De50a100m2'
  | 'PlusDe100m2';
export const DependencyTypes = {
  _none: 'None' as DependencyTypes,
  _0_50m2: '_0_50m2' as DependencyTypes,
  _0_40m2: '_0_40m2' as DependencyTypes,
  _50_100m2: '_50_100m2' as DependencyTypes,
  _100_250m2: '_100_250m2' as DependencyTypes
};
